import { Roles } from "./roles";
import { getUserByEmail, getUsers, getUserById } from "./api";

export const GOODLEAP_SUBMITTING_USER_DOMAIN = "goodleap.com";

export function isGoodleapDomainEmail(email) {
  const normalized = String(email ?? "").trim().toLowerCase();
  if (!normalized.includes("@")) return false;
  return normalized.endsWith(`@${GOODLEAP_SUBMITTING_USER_DOMAIN}`);
}

export function userEmailFromRecord(user, userById) {
  return (userById?.email ?? user?.email ?? "").trim();
}

export function salesRepFromUserRecord(user, userById) {
  return {
    firstName: userById?.firstName ?? user?.firstName ?? "",
    lastName: userById?.lastName ?? user?.lastName ?? "",
    email: userEmailFromRecord(user, userById),
    phone:
      userById?.phoneNumber?.number ??
      user?.phoneNumber?.number ??
      user?.phones?.[0]?.number ??
      "",
  };
}

/** True when configured email exists in partner API and is not @goodleap.com. */
export async function configuredSubmittingUserExists(
  clientId,
  submittingUserEmail,
  token
) {
  const response = await getUserByEmail(clientId, submittingUserEmail, token);
  if (!response?.data?.length) return false;
  return response.data.some(
    (user) => !isGoodleapDomainEmail(user?.email ?? submittingUserEmail)
  );
}

/**
 * First user matching Roles priority (utils/roles.js), excluding @goodleap.com.
 * @returns {{ substitute: object, roleName: string }|null}
 */
export async function findSubstituteSubmittingUser(clientId, token) {
  const users = await getUsers(clientId, token);
  if (!users?.data?.length) return null;

  const candidates = [];
  for (const user of users.data) {
    const userById = await getUserById(clientId, user.id, token);
    const email = userEmailFromRecord(user, userById);
    if (isGoodleapDomainEmail(email)) continue;

    const roleName = userById?.role?.name;
    if (!roleName || !Roles.includes(roleName)) continue;

    candidates.push({ user, userById, roleName });
  }

  for (const role of Roles) {
    const match = candidates.find((candidate) => candidate.roleName === role);
    if (match) {
      return {
        substitute: salesRepFromUserRecord(match.user, match.userById),
        roleName: match.roleName,
      };
    }
  }

  return null;
}

export const submittingUserSubstituteNotFoundMessage =
  "No submitting user found and no eligible substitute user found for configured roles";
